<template>
	<div class="list-group border-radius-2 no-border" v-if="ready">
		<WidgetHeader link="/timetables/individual"> {{ $t('timetable') }} </WidgetHeader>

		<template v-if="Object.keys(events).length">
			<template v-for="period in events">
				<div v-for="event in period" :key="event.tt_event_id" class="list-group-item">
					<p>
						<strong>{{event.ttsessiontype_name}}</strong>
						{{event.ttroom_name}}
						<template v-if="event.ttevent_notes"><br/>{{event.ttevent_notes}}</template>
						<br/>{{$datetime.timestampToTime(event.ttevent_datetimefrom, false)}} -
						{{$datetime.timestampToTime(event.ttevent_datetimeto, false)}}
					</p>
				</div>
			</template>
		</template>
		<div class="list-group-item" v-else>{{ $t('no-items-today') }}</div>

	</div>
</template>

<script>
import WidgetHeader from "./WidgetHeader";

export default {
	components: {
		WidgetHeader
	},
	data() {
		return {
			ready: false,
			events: []
		}
	},
	methods: {
		loadTimetable: function () {
			this.$cfetch(`${this.$settings.APIBaseURL}/timetable/tttimetable/getstudenttimetable`, {
				data: {
					today: true
				}
			}).then((res) => {
				if (res.status === "SUCCESS") {
					this.ready = true;
					this.events = res.result.timetable.events;
				}
			});
		},
	},
	mounted() {
		this.loadTimetable();
	}
};
</script>
